export function splitObjectValues(obj) {
    const obj1 = {};
    const obj2 = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            const halfIndex = Math.ceil(value.length / 2);
            obj1[key] = value.substring(0, halfIndex);
            obj2[key] = value.substring(halfIndex);
        }
    }

    return [obj1, obj2];
}

export const generateKeysJson = cryptoKeys => {
    const publicKeyStringified = JSON.stringify(cryptoKeys.publicKey);

    const privateKeyStringified = JSON.stringify(cryptoKeys.privateKey);

    return { publicKeyStringified, privateKeyStringified };
};

export const handleNewP2Pkeys = async (keyPair: {
    publicKey: string;
    privateKey: string;
}) => {
    const { privateKeyStringified, publicKeyStringified } = generateKeysJson({
        publicKey: keyPair.publicKey,
        privateKey: keyPair.privateKey,
    });

    return {
        privateKeyStringified,
        publicKeyStringified,
    };
};
